import {Injectable} from 'ng-metadata/core';
import{AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class UBRequest extends AbstractRequest {

    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ){
        super();
        this.formFields= [
            {
                key: 'ils_db_c',
                name: 'ils_db_code',
                path: 'groups-list-map/ils_db',
                label: 'ubrequest.dropdown.select_library',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key:    'ils_db_code',
                        value: 'ils_db_name'
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },
            {
                key: 'itemid',
                name: 'itemid',
                path: 'groups-list-map/items',
                label: 'ubrequest.label.select_item',
                mandatory: true,
                dependOn: {key : 'ils_db_code', isExists: true, behavior: FormBuilderEnums.BEHAVIOR.DISABLED},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key:   'itemid',
                        value: 'itemdescription',
                        defaultValue: FormBuilderEnums.FIRST,
                        filters :['ils_db_code']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            }, 
            {
                key: 'pickup_library_name',
                name: 'pickup_library_code',
                path: 'groups-list-map/pickup_library',
                label: 'ubrequest.dropdown.pickup_library',
                mandatory: true,
                dependOn: {key : 'ils_db_code', isExists: true, behavior: FormBuilderEnums.BEHAVIOR.DISABLED},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key:    'pickuplibrarycode',
                        value: 'pickuplibraryname',
                        defaultValue: FormBuilderEnums.FIRST,
                        filters :['ils_db_code','itemid']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            }, 
            {
                key: 'pickup_location_name',
                name: 'pickup_location_code',
                path: 'groups-list-map/pickup_location',
                label: 'ubrequest.dropdown.pickup_location',
                mandatory: true,
                dependOn: {key : 'ils_db_code', isExists: true, behavior: FormBuilderEnums.BEHAVIOR.DISABLED},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key:    'pickuplocationcode',
                        value: 'pickuplocationname',
                        defaultValue: FormBuilderEnums.FIRST,
                        filters :['ils_db_code', 'itemid', 'pickup_library_code']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },
            {
                key: 'last_interest_date',
                name: 'last_interest_date',
                label: 'ubrequest.last_interest_date',
                path: 'ub-last-interest-date',
                valuePath: 'ub-last-interest-date',
                existingPath: 'describe-item/lastinterestdate',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator: {
                    params: {
                        defaultValue: FormBuilderEnums.TODAY,
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'item_request_link',
                name: 'item_request_link',
                label: '',
                path: 'describe-item/db/item{ils_db_code:ilsdbcode}/itemrequestlink',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
                    }
                   
                }
            },
            {
                key: 'comment',
                name: 'patron_note_1',
                label: 'ubrequest.patron_note_1',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            }
            
            
        ];
        
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/ubRequest.ts